export default "__VITE_ASSET__DNLZlkRU__"